module.exports = __webpack_public_path__ + "media/img/info/magazine-bd5730fa9533b3c5c7c84081c4172b60.png";